import PeriodBar from "@/components/layout/PeriodBar";
import RoleSwitcher from "@/components/layout/RoleSwitcher";
import NotificationsCenter from "@/components/layout/NotificationsCenter";
import TitleStylePanel from "@/components/layout/TitleStylePanel";
import BrandIdentityPanel from "@/components/layout/BrandIdentityPanel";
import UserMenu from "@/components/layout/UserMenu";
import { useApp } from "@/store/AppStore";

interface TopBarProps {
  onOpenMenu: () => void;
  onRoleSwitch?: (role: "admin" | "asesor") => void;
}

const TopBar = ({ onOpenMenu, onRoleSwitch }: TopBarProps) => {
  const { data } = useApp();

  return (
    <header className="sticky top-0 z-30 glass-panel border-x-0 border-t-0">
      <div className="flex flex-wrap items-center gap-3 px-4 md:px-6 py-3">
        <button
          onClick={onOpenMenu}
          className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md border border-accent-500/20 bg-background-200/50 text-foreground-800 cursor-pointer"
          aria-label="Abrir menú"
        >
          <i className="ri-menu-2-line text-lg" />
        </button>

        <div className="flex items-center gap-2 mr-auto">
          <span className="hidden md:flex items-center gap-2 text-xs font-semibold text-foreground-500">
            <span className="w-5 h-5 flex items-center justify-center text-accent-300">
              <i className="ri-time-line" />
            </span>
            Período de gestión
          </span>
          <PeriodBar />
        </div>

        <div className="flex items-center gap-2">
          <RoleSwitcher onSwitch={onRoleSwitch} />
          {data.role === "admin" && <BrandIdentityPanel />}
          <TitleStylePanel />
          <NotificationsCenter />
          <UserMenu />
        </div>
      </div>
    </header>
  );
};

export default TopBar;